import { lazy } from 'react';

import { PageSuspense } from 'src/components';


const ProductFullUpdatePage = lazy(() => import('../views/update/ProductFullUpdatePage'));

export function ProductFullUpdatePageLazy() {
	return (
		<PageSuspense>
			<ProductFullUpdatePage />
		</PageSuspense>
	);
}
